// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGExpand = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsx("g", {
    clipPath: "url(#expand__clip0_5218_10983)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M4.046 5.185c.022.03.047.06.073.087l5.047 5.055h-2.39c-.461 0-.836.375-.836.837 0 .461.375.836.837.836h4.33c.226-.001.432-.092.582-.239.159-.154.257-.369.258-.607V6.83c0-.23-.093-.44-.243-.592-.152-.151-.362-.245-.593-.245-.463 0-.839.375-.841.837v2.328L5.257 4.149c-.032-.033-.066-.062-.102-.088L2.767 1.673h2.39c.461 0 .836-.375.836-.837C5.993.375 5.618 0 5.156 0H.832C.372 0 0 .372 0 .832v4.305c0 .231.093.44.244.593.152.15.361.244.592.244.463 0 .839-.374.841-.837V2.805l2.369 2.38z"
    })
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "expand__clip0_5218_10983",
      children: /*#__PURE__*/_jsx("path", {
        transform: "rotate(-90 6 6)",
        d: "M0 0h12v12H0z"
      })
    })
  })]
}));
SVGExpand.displayName = 'SVGExpand';
export default SVGExpand;